import StatusBadge from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MessageCircle } from "lucide-react";

export function InterestsDialog({ interestsFor, setInterestsFor, interestsList, onChat, onChoose }) {
  return (
    <Dialog open={!!interestsFor} onOpenChange={(o) => !o && setInterestsFor(null)}>
      <DialogContent className="rounded-md max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display">Geïnteresseerde professionals</DialogTitle>
          <DialogDescription>{interestsFor?.titel} — chat met professionals en kies de juiste.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {interestsList.length === 0 && (
            <p className="text-center text-sm text-slate-400 py-8">Nog geen professionals hebben interesse getoond.</p>
          )}
          {interestsList.map((it) => (
            <div key={it.monteur_id} data-testid="interesse-row" className="border border-slate-200 rounded-md p-3">
              <div className="flex items-center justify-between mb-2">
                <div>
                  <p className="font-display font-bold text-slate-950">{it.monteur_name}</p>
                  {it.monteur && (
                    <p className="text-xs text-slate-500">
                      {it.monteur.regio || "—"} · {it.monteur.ervaring_jaren || 0} jr ervaring
                      {it.monteur.talen?.length ? ` · ${it.monteur.talen.join(", ")}` : ""}
                    </p>
                  )}
                </div>
                {it.gekozen && <StatusBadge status="toegewezen" />}
              </div>
              <div className="flex gap-2">
                <Button data-testid="interesse-chat-btn" onClick={() => onChat(interestsFor, it.monteur_id)}
                  variant="outline" className="flex-1 rounded-sm font-semibold border-slate-300">
                  <MessageCircle className="w-4 h-4 mr-2" /> Chat
                </Button>
                {!interestsFor?.monteur_id && (
                  <Button data-testid="kies-monteur-btn" onClick={() => onChoose(it.monteur_id)}
                    className="flex-1 bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold">
                    Kies deze professional
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
